import React from 'react';
import { Dropdown, Button } from 'react-bootstrap';
import UIStore from 'src/stores/alt/stores/UIStore';
import PermissionStore from 'src/stores/alt/stores/PermissionStore';
import PermissionActions from 'src/stores/alt/actions/PermissionActions';
import SelectionShareModal from 'src/apps/mydb/elements/list/selectionActions/SelectionShareModal';
import SelectionTransferModal from 'src/apps/mydb/elements/list/selectionActions/SelectionTransferModal';
import SelectionDeleteModal from 'src/apps/mydb/elements/list/selectionActions/SelectionDeleteModal';
import SelectionRemoveModal from 'src/apps/mydb/elements/list/selectionActions/SelectionRemoveModal';
import SelectionUserLabelsModal from 'src/apps/mydb/elements/list/selectionActions/SelectionUserLabelsModal';
import ElementActions from 'src/stores/alt/actions/ElementActions';
import SelectionSplitButton from 'src/apps/mydb/elements/list/selectionActions/SelectionSplitButton';
import SelectionGenerateButton from 'src/apps/mydb/elements/list/selectionActions/SelectionGenerateButton';
import SelectionExportButton from 'src/apps/mydb/elements/list/selectionActions/SelectionExportButton';
import AppModal from 'src/components/common/AppModal';
import { elementNames } from 'src/apps/generic/Utils';
import { PermissionConst } from 'src/utilities/PermissionConst';

export default class SelectionActions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModalOfType: null,
      currentCollection: { id: 0 },
      sharing_allowed: false,
      deletion_allowed: false,
      remove_allowed: false,
      update_allowed: false,
      is_top_secret: false,
    };

    this.onChange = this.onChange.bind(this);
    this.onPermissionChange = this.onPermissionChange.bind(this);

    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
  }

  componentDidMount() {
    UIStore.listen(this.onChange);
    PermissionStore.listen(this.onPermissionChange);
  }

  componentWillUnmount() {
    UIStore.unlisten(this.onChange);
    PermissionStore.unlisten(this.onPermissionChange);
  }

  async onChange(state) {
    const { currentCollection } = state;
    if (this.collectionChanged(state)) {
      this.setState({
        sharing_allowed: false,
        deletion_allowed: false,
        remove_allowed: false,
        update_allowed: false,
        is_top_secret: false,
        hasSel: false,
        currentCollection
      });
    } else {
      const klassArray = await elementNames(true);
      const newHasSel = klassArray.some((el) => (state[el] && (state[el].checkedIds.size > 0 || state[el].checkedAll)));
      if (state.currentCollection) {
        PermissionActions.fetchPermissionStatus(state);
      }
      const { hasSel } = this.state;
      if (newHasSel !== hasSel) this.setState({ hasSel: newHasSel });
    }
  }

  onPermissionChange(state) {
    this.setState({ ...state });
  }

  collectionChanged(state) {
    const { currentCollection } = state;
    if (typeof currentCollection === 'undefined' || currentCollection == null) {
      return false;
    }
    const { id } = currentCollection;
    return this.state.currentCollection.id !== id;
  }

  showModal(type) {
    this.setState({ showModalOfType: type });
  }

  hideModal() {
    this.setState({ showModalOfType: null });
  }

  renderTopSecretModal() {
    return (
      <AppModal
        show
        onHide={this.hideModal}
        title="Sharing not allowed"
      >
        One of the selected elements contains one or several samples marked as top secret.
      </AppModal>
    );
  }

  renderModal() {
    const { showModalOfType, is_top_secret } = this.state;
    switch (showModalOfType) {
      case 'share':
        return is_top_secret
          ? this.renderTopSecretModal()
          : <SelectionShareModal onHide={this.hideModal} />;

      case 'move':
        return <SelectionTransferModal
          title="Move to Collection"
          action="move"
          withShared={true}
          withRepository={true}
          onHide={this.hideModal}
        />;

      case 'assign':
        return <SelectionTransferModal
          title="Assign to Collection"
          action="assign"
          withShared={false}
          withRepository={true}
          onHide={this.hideModal}
        />;

      case 'remove':
        return <SelectionRemoveModal onHide={this.hideModal} />;

      case 'user_labels':
        return <SelectionUserLabelsModal onHide={this.hideModal} />;

      case 'delete':
        return <SelectionDeleteModal onHide={this.hideModal} />;

      default:
        return null;
    }
  }

  render() {
    const {
      currentCollection, sharing_allowed, deletion_allowed, remove_allowed, update_allowed, hasSel
    } = this.state;
    const { is_locked, label } = currentCollection;
    const isAll = is_locked && label === 'All';
    const noSel = !hasSel;

    // Move unlinks from the current collection, so it needs remove permission on the source.
    const moveDisabled = noSel || isAll || !remove_allowed;
    const assignDisabled = noSel;
    const removeDisabled = noSel || isAll || !remove_allowed;
    const deleteDisabled = noSel || !deletion_allowed;
    const shareDisabled = noSel || !sharing_allowed;
    const literatureDisabled = noSel;
    // Assigning user labels edits the elements, which requires :edit_elements (update_all?),
    // so it must be disabled on read-only shared collections.
    const userLabelsDisabled = noSel || !update_allowed;

    return (
      <div className="selection-actions d-flex align-items-center gap-1 mb-3">
        <SelectionGenerateButton />
        <SelectionExportButton />
        {/* Split creates a new sub-element in the *current* collection, so it is gated on that
            collection being writable (:add_elements+), not on record-level sharing_allowed — which
            takes the MAX permission across every collection a record belongs to and would stay true
            when the same record is also writable elsewhere. Owned collections omit permission_level
            (writable); shared collections expose it. */}
        <SelectionSplitButton
          collectionWritable={
            currentCollection.permission_level == null
            || currentCollection.permission_level >= PermissionConst.AddElements
          }
        />
        <Dropdown id="move-or-assign-btn">
          <Dropdown.Toggle
            variant="light"
            size="sm"
            disabled={assignDisabled && moveDisabled}
            title="Transfer"
            aria-label="Transfer"
          >
            <i className="fa fa-exchange me-1" aria-hidden="true" />
            <span className="selection-action-text-label">Transfer</span>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item
              onClick={() => this.showModal('move')}
              disabled={moveDisabled}
            >
              Move to Collection
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => this.showModal('assign')}
              disabled={assignDisabled}
            >
              Assign to Collection
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        <Dropdown id="remove-or-delete-btn">
          <Dropdown.Toggle
            variant="light"
            size="sm"
            disabled={removeDisabled && deleteDisabled}
            title="Remove"
            aria-label="Remove"
          >
            <i className="fa fa-times-circle-o me-1" aria-hidden="true" />
            <span className="selection-action-text-label">Remove</span>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item
              onClick={() => this.showModal('remove')}
              disabled={removeDisabled}
            >
              Remove from current Collection
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => this.showModal('delete')}
              disabled={deleteDisabled}
            >
              Remove from all Collections
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
        <Button
          variant="light"
          size="sm"
          id="share-btn"
          disabled={shareDisabled}
          onClick={() => this.showModal('share')}
          title="Share"
          aria-label="Share"
        >
          <i className="fa fa-share-alt me-1" aria-hidden="true" />
          <span className="selection-action-text-label">Share</span>
        </Button>
        <Button
          variant="light"
          size="sm"
          id="literature-btn"
          disabled={literatureDisabled}
          onClick={ElementActions.showLiteratureDetail}
          title="References"
          aria-label="References"
        >
          <i className="fa fa-book me-1" aria-hidden="true" />
          <span className="selection-action-text-label">References</span>
        </Button>
        <Button
          variant="light"
          size="sm"
          id="user-labels-btn"
          disabled={userLabelsDisabled}
          onClick={() => this.showModal('user_labels')}
          title="User labels"
          aria-label="User labels"
        >
          <i className="fa fa-tags me-1" aria-hidden="true" />
          <span className="selection-action-text-label">My labels</span>
        </Button>
        {this.renderModal()}
      </div>
    );
  }
}
